"use client";

import React from "react";
import { LayoutGrid, Sparkles, Route, Sun, Trees, Fence, BrickWall, Grip, Layers } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const servicesData = [{
  title: "Proactive Monitoring",
  description: "We watch your systems 24/7 to catch and resolve issues before they disrupt your workflow.",
  icon: LayoutGrid
}, {
  title: "Helpdesk Support",
  description: "Friendly, local experts ready to solve your technical hurdles with a warm, human touch.",
  icon: Sparkles
}, {
  title: "Cybersecurity",
  description: "Multi-layered protection strategies designed to keep your business data safe and compliant.",
  icon: Route
}, {
  title: "Cloud Management",
  description: "Seamlessly migrate and manage your cloud infrastructure for maximum flexibility and scale.",
  icon: Sun
}, {
  title: "Network Design",
  description: "Custom-built network architectures that grow alongside your business requirements.",
  icon: Trees
}, {
  title: "Data Backup",
  description: "Automated, redundant backup solutions ensuring your critical information is never lost.",
  icon: Fence
}, {
  title: "IT Consulting",
  description: "Strategic technology roadmaps to align your IT investments with your long-term goals.",
  icon: BrickWall
}, {
  title: "Remote Access",
  description: "Secure and reliable remote work solutions for your team, no matter where they are.",
  icon: Grip
}, {
  title: "Pricing Transparency",
  description: "Managed services starting at $125/mo. No hidden fees, just honest partnership.",
  icon: Layers
}];
export default function OurPavingLandscapingExpertise() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="222733" id="our-msp-core-pillars" className="bg-background text-foreground py-24">
      <div className="container mx-auto max-w-7xl px-4 md:px-8">
        <div className="mb-16 text-center">
          <h2 className="font-default text-secondary mb-4 text-3xl font-bold md:text-4xl lg:text-5xl">
            Our MSP Core Pillars
          </h2>
          <p className="text-muted-foreground font-default mx-auto max-w-2xl text-lg">
            We don&apos;t just fix computers; we partner with you to drive growth through reliable, human-centric technology solutions.
          </p>
        </div>

        <div ref={ref} className={`grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3 transition-opacity duration-1000 ${isVisible ? "opacity-100" : "opacity-0"}`}>
          {servicesData.map((service, i) => {
          const Icon = service.icon;
          const isPricing = service.title === "Pricing Transparency";
          return <div key={service.title} data-index={i} className={`group bg-card border-border ${isPricing ? 'hover:border-primary' : 'hover:border-secondary'} hover:shadow-2xl flex flex-col items-center rounded-2xl border p-12 text-center transition-all duration-300`}>
                <div className={`${isPricing ? 'text-primary' : 'text-secondary'} mb-6 transition-transform duration-300 group-hover:scale-110`}>
                  <Icon className="size-12" strokeWidth={1.5} />
                </div>
                <h3 className="font-default text-foreground mb-4 text-xl font-bold">
                  {service.title}
                </h3>
                <p className="text-muted-foreground font-default text-base leading-relaxed">
                  {service.description}
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}